export default {"src":"/_next/static/media/circleMinus_24.bad3a2e3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};